'use strict';

var m = angular.module('ui.utils.masks.us', [
	require('../helpers')
])
.directive('uiUsPhoneNumber', require('./phone/us-phone'));

module.exports = m.name;



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-input-masks/src/us/us-masks.js
// module id = 1749
// module chunks = 12